export function request (params, pagination) {
  return {
    symbol: 'OTCM',
    companyName: 'OTC Markets Group Inc.',
    logoUrl: '/newly-trading/logo.png'
  }
}
